import React, {Component} from 'react'
import queryString from "query-string"
import PropTypes from 'prop-types'
import {Select} from "antd"
import {listPartner} from "../../../services/api/3dApi"

const {Option} = Select

class SelectPartnerSewing extends Component {
    constructor(props) {
        super(props)

        this.state = {
            listPartner: []
        }
    }

    componentDidMount() {
        this._fetchPartnerSewing()
    }

    _fetchPartnerSewing = async () => {
        this.setState({
            loading: true,
            error: ''
        })

        try {
            const payload = {
                type: 'sewing_partner'
            }

            const query = queryString.stringify(payload)

            const {data: response} = await listPartner(query)

            const {success, data, error} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: error
                })
            }

            this.setState({
                loading: false,
                listPartner: data.partners
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message
            })
        }
    }

    _handleChangePartner = (value) => {
        const {onChangePartner} = this.props

        if (typeof onChangePartner === 'function') {
            onChangePartner(value)
        }
    }

    render() {
        const {listPartner, error} = this.state
        const {partner} = this.props

        return (
            <div className='SelectPartnerSewing mb-3'>
                <label className='d-block'>Chọn đối tác may (<span className='text-danger'>* bắt buộc</span>)</label>
                <Select
                    size='large'
                    value={partner}
                    onChange={this._handleChangePartner}
                    className='Custom'
                    showSearch
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                >
                    <Option value=''>--- Chọn đối tác may ---</Option>
                    {
                        listPartner.length > 0 && listPartner.map(item =>
                            <Option key={item._id} value={item._id} title={item.name}>{item.name}</Option>
                        )
                    }
                </Select>

                {
                    error && <div className="text-danger mt-3">{error}</div>
                }
            </div>
        )
    }
}

SelectPartnerSewing.propTypes = {
    partner: PropTypes.string
}

export default SelectPartnerSewing
